<template>
  <div class="home-content">
    <div class="second-pard">
      <ul>
        <li @click="sortPrice('name')">Currency<div class="red">{{ sortTo['name'] }}</div></li>
        <li @click="sortPrice('now_price')">Real Price<div class="red">{{ sortTo['now_price'] }}</div></li>
        <li @click="sortPrice('rate')">Rise Fall<div class="red">{{ sortTo['rate'] }}</div></li>
      </ul>
    </div>
    <div class="third-pard">
      <ul v-for="(i, index) in list" v-bind:key="index" @click="util.topage('kline', i.name, i.name_2)">
        <li class="name">
          <img :src="i.coin_img" :class="(i.name == 'UNI' || i.name == 'XAUT') ? 'spe' : ''" />
          <div>{{ i.name }}/USDT</div>
        </li>
        <li :class="i.rate >= 0 ? 'green' : 'red'">{{ i.now_price }}</li>
        <li>
          <div :class="i.rate >= 0 ? 'change down' : 'change up'">{{ i.rate }}%</div>
        </li>
      </ul>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
export default {
  data() {
    return {
      list: [],
      showloding: false,
      sortParam: {},
      sortAsc: { name: true, now_price: true, rate: true },
      sortTo: { name: "", now_price: "", rate: "" },
      timer: null
    };
  },
  methods: {
    sortPrice(key) {
      let asc = this.sortAsc[key];
      this.sortTo = { name: "", now_price: "", rate: "" };
      if (asc) this.sortTo[key] = "↑";
      else this.sortTo[key] = "↓";
      this.sortParam = { key: key, asc: asc };
      this.sortAsc[key] = !asc;
      this.list = this.util.objArraySort(this.list, this.sortParam);
    },
    getGains() {
      let set_data = {
        flag: 2,
        sortName: 0,
        sort: 0,
        userName: this.util.user.login_name,
        userToken: this.util.user.token
      }
      this.axios.get(this.api.api_findNowPriceGains, {
        params: {
          ...set_data,
          dn_value: this.util.get_dn_value(set_data)
        }
      }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          let new_data
          let list = res.data.data.map(item => {
            if (item.name == 'bch') new_data = item
            if (item.name == 'btg') {
              return {
                name: item.name.toUpperCase(),
                name_2: 'bch',
                now_price: new_data.now,
                coin_img: require('@/assets/images/coin/' + item.name.toUpperCase() + '.png'),
                rate: parseFloat(new_data.rate).toFixed(2),
              }
            } else {
              return {
                name: item.name.toUpperCase(),
                name_2: item.name.toUpperCase(),
                now_price: item.now,
                coin_img: require('@/assets/images/coin/' + item.name.toUpperCase() + '.png'),
                rate: parseFloat(item.rate).toFixed(2),
              }
            }
          })
          this.list = this.util.objArraySort(list, this.sortParam);
          let currentPath = this.$route.path;
          if (currentPath == '/market') {
            this.timer = setTimeout(() => {
              if (this.util.isLogin()) { this.getGains(); }
            }, this.util.refreshTime);
          } else {
            window.clearTimeout(this.timer)
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
  },
  mounted() {
    if (this.util.isLogin()) {
      this.getGains();
    }
  },
  destroyed() {
    window.clearTimeout(this.timer)
  },
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.32rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;

  .first-pard {
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.36rem;
    font-weight: bold;
    color: black;
    border-bottom: 1px solid white;
  }

  .second-pard {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: white;
      font-size: 0.34rem;
      height: 40px;
      color: black;
      font-weight: bolder;
      border-bottom: 1px solid rgb(235, 235, 235);

      li {
        width: 110px;
        padding: 10px;
        display: flex;
      }

      :nth-child(2) {
        display: flex;
        justify-content: center;
      }

      :nth-child(3) {
        display: flex;
        justify-content: right;
      }
    }
  }

  .third-pard {
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0 auto;
    padding-bottom: 180px;
    height: 100%;
    background: white;
    text-align: center;

    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;

      .name {
        display: flex;
        align-items: center;
        width: 80px;
        font-size: 0.32rem;

        img {
          display: block;
          margin: auto 6px;
          width: 34px;
        }

        .spe {
          border: solid 1px rgb(193, 193, 193);
          border-radius: 50%;
        }
      }

      li .change {
        margin-right: 5px;
        width: 80px;
        padding: 5px;
        height: 30px;
        border-radius: 4px/4px;
      }
    }
  }
}
</style>